module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pendingReady && _vm.affiliationsList.length) ? _c('div', {
    class: _vm.rootClass
  }, [_c('p', {
    staticClass: "affil-heading"
  }, [_vm._v("Institution Invitations")]), _vm._v(" "), _vm._l((_vm.affiliationsList), function(invite) {
    return _c('div', {
      key: invite.id,
      staticClass: "affil-row"
    }, [_c('span', {
      staticClass: "affil-mark",
      style: ({
        backgroundColor: _vm.colorFor(invite)
      })
    }, [_vm._v(_vm._s(_vm.initialsFor(invite)))]), _vm._v(" "), _c('span', {
      staticClass: "affil-body"
    }, [_c('span', {
      staticClass: "affil-name",
      attrs: {
        "title": invite.institutionName
      }
    }, [_vm._v("Affiliate with " + _vm._s(invite.institutionName || 'an institution'))]), _vm._v(" "), _c('span', {
      staticClass: "affil-copy"
    }, [_vm._v("You'll get a Cuelist license paid for by the institution. They can deactivate or remove it later.")])]), _vm._v(" "), _c('span', {
      staticClass: "affil-btns"
    }, [_c('button', {
      staticClass: "affil-btn affil-accept",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.accept(invite)
        }
      }
    }, [_vm._v("Accept")]), _vm._v(" "), _c('button', {
      staticClass: "affil-btn affil-decline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.decline(invite)
        }
      }
    }, [_vm._v("Decline")])])])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-026b9d9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/pending-affiliations.vue
// module id = 1198
// module chunks = 21